import {
  Datagrid,
  LongTextField,
  StateCollectionInput,
} from "ra-friendsofbabba";
import {
  DateField,
  NumberField,
  List as RaList,
  TextField,
  usePermissions,
} from "react-admin";

import Actions from "./Actions";
import BulkActions from "./BulkActions";
import EditOrViewButton from "./buttons/EditOrViewButton";
import Empty from "./Empty";
import Filters from "./Filters";
import ProgressField from "./fields/ProgressField";
import React from "react";
import UserField from "../component/field/UserField";
import useView from "../research-projects/useView";

const List = (props) => {
  const { loaded, permissions } = usePermissions();
  const isView = useView();
  const isAdmin = loaded && permissions(["admin", "president"]);
  return (
    <RaList
      {...props}
      empty={<Empty />}
      actions={<Actions />}
      bulkActionButtons={isAdmin ? <BulkActions /> : false}
      sort={
        isView
          ? { field: "ResearchProjects.progressive_number", order: "ASC" }
          : {
              field: "Points.total",
              order: "DESC",
            }
      }
      filters={<Filters />}
    >
      <Datagrid rowClick="edit">
        <TextField
          source="research_project.progressive_number"
          sortBy="ResearchProjects.progressive_number"
          label="#ID"
        />
        <StateCollectionInput
          source="state"
          readonly={!isAdmin}
          admin={isAdmin}
          sortable={false}
        />
        <TextField
          source="research_project.code"
          sortBy="ResearchProjects.code"
          label="resources.research-projects.fields.code"
        />
        <LongTextField
          source="research_project.title"
          sortBy="ResearchProjects.title"
          label="resources.research-projects.fields.title"
        />
        <UserField
          source="user.name"
          label="resources.research-project-evals.fields.user_id"
          sortBy="UserProfiles.name"
        />
        <ProgressField source="progress" sortBy="progress" />
        <NumberField source="total_points" sortBy="Points.total" />

        <DateField source="modified" showTime />
        <EditOrViewButton />
      </Datagrid>
    </RaList>
  );
};

export default List;
